import { jsx as _jsx } from "react/jsx-runtime";
import { queries } from "@bluframe/mightychroma-mightytool-graphql-schema";
import List from "components/Lists/List";
import DELETE_CONTEST from "mutations/contests/deleteContest";
const { contests: { GET_CONTESTS } } = queries;
const ContestsList = () => (_jsx(List, { deleteMutation: DELETE_CONTEST, itemNamePlural: "contests", label: "Contests", listQuery: GET_CONTESTS, listQueryDataName: "getContests" }));
export default ContestsList;
